import {
  blue,
  cyan,
  deepPurple,
  green,
  grey,
  indigo,
  orange,
  purple,
  red,
  yellow,
} from "@mui/material/colors";
import Co2Icon from "@mui/icons-material/Co2";
import BarPressIcon from "assets/icons/BarPress.icon";
import UmbrellaIcon from "assets/icons/Umbrella.icon";
import { WiDust, WiStrongWind } from "react-icons/wi";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import {
  IconAccessPoint,
  IconRouter,
  IconUsers,
  IconVideoMinus,
  IconWifi,
  IconDroplet,
  IconTemperatureCelsius,
  IconCircles,
} from "@tabler/icons";

export const getTrend = (value, t) => {
  switch (value) {
    case "dec_high":
      return t("high-decrement");
    case "dec_mid":
      return t("average-decrease");
    case "dec_low":
      return t("low-decrement");

    case "inc_high":
      return t("high-increment");
    case "inc_mid":
      return t("medium-increment");
    case "inc_low":
      return t("low-increment");
    case "stable":
      return t("stable");

    case "variable":
      return t("variable");
    default:
      return "";
  }
};

export const optionsMetrics = [
  {
    label: "temperature",
    value: "air_temp",
    name: "air_temp",
    data: [{ label: "temperature", endpoint: "air_temp" }],
  },
  {
    label: "humidity",
    value: "air_hum",
    name: "air_hum",
    data: [{ label: "humidity", endpoint: "air_hum" }],
  },
  {
    label: "CO2",
    value: "CO2",
    name: "CO2",
    data: [{ label: "CO2", endpoint: "CO2" }],
  },
  {
    label: "illuminance",
    value: "lux",
    name: "lux",
    data: [{ label: "illuminance", endpoint: "lux" }],
  },
  {
    label: "Rainfall",
    value: "rain_intensity,rain_intensity_peak",
    name: "rain_intensity,rain_intensity_peak",
    data: [
      { label: "Intensity", endpoint: "rain_intensity" },
      { label: "Peak", endpoint: "rain_intensity_peak" },
    ],
  },
  {
    label: "Wind",
    value: "wind_speed,wind_dir_idx",
    name: "wind_speed,wind_dir_idx",
    data: [
      { label: "Speed", endpoint: "wind_speed" },
      { label: "Direction", endpoint: "wind_dir_idx" },
    ],
  },
  {
    label: "Air quality",
    value: "pm10,pm2_5",
    name: "pm10,pm2_5",
    data: [
      { label: "PM 10", endpoint: "pm10" },
      { label: "PM 2.5", endpoint: "pm2_5" },
    ],
  },
  {
    label: "atmospheric-pressure",
    value: "bar_press",
    name: "bar_press",
    data: [{ label: "Pressure", endpoint: "bar_press" }],
  },
  {
    label: "people-counter",
    value: "pcount",
    name: "pcount",
    data: [{ label: "people-counter", endpoint: "pcount" }],
  },
];

export const optionsFiltersStations = [
  {
    label: "All",
    name: "elenco_poi",
    value: "elenco_poi",
    icon: <IconCircles color="white" width={20} height={20} />,
  },
  {
    label: "Basic environmental monitoring",
    name: "base_point",
    value: "base_point",
    icon: <IconRouter color="white" width={20} height={20} />,
  },
  {
    label: "Advanced environmental monitoring",
    name: "advanced_point",
    value: "advanced_point",
    icon: <IconRouter color="white" width={20} height={20} />,
  },
  {
    label: "people-counter",
    name: "PC",
    value: "PC",
    icon: <IconUsers color="white" width={20} height={20} />,
  },
  {
    label: "Camera",
    name: "camera",
    value: "camera",
    icon: <IconVideoMinus color="white" width={20} height={20} />,
  },
  {
    label: "WiFi",
    name: "wifi",
    value: "wifi",
    icon: <IconWifi color="white" width={20} height={20} />,
  },
  {
    label: "Gateway",
    name: "gateway",
    value: "gateway",
    icon: <IconAccessPoint color="white" width={20} height={20} />,
  },
];

export const propsStatsMetricsCard = Object.freeze({
  air_temp: {
    avatarcolor: red[800],
    icon: <IconTemperatureCelsius fontSize="inherit" />,
    symbol: "°C",
  },
  air_hum: {
    avatarcolor: indigo[800],
    icon: <IconDroplet fontSize="inherit" />,
    symbol: "%",
  },
  bar_press: {
    avatarcolor: green[800],
    icon: <BarPressIcon fontSize="inherit" width={70} height={70} />,
    symbol: "hPa",
  },
  CO2: {
    avatarcolor: grey[800],
    icon: <Co2Icon fontSize="inherit" />,
    symbol: "ppm",
  },
  lux: {
    avatarcolor: yellow[900],
    icon: <WbSunnyOutlinedIcon fontSize="inherit" />,
    symbol: "lux",
  },
  pm2_5: {
    avatarcolor: deepPurple[800],
    icon: <WiDust />,
    symbol: "µg/m³",
  },
  pm10: {
    avatarcolor: purple[800],
    icon: <WiDust />,
    symbol: "µg/m³",
  },
  rain_intensity: {
    avatarcolor: blue[500],
    icon: <UmbrellaIcon fontSize="inherit" width={70} height={70} />,
    symbol: "mm",
  },
  rain_intensity_peak: {
    avatarcolor: "#1d5c8f",
    icon: <UmbrellaIcon fontSize="inherit" width={70} height={70} />,
    symbol: "mm",
  },
  wind_speed: {
    avatarcolor: cyan[700],
    icon: <WiStrongWind />,
    symbol: "km/h",
  },
  wind_dir_idx: {
    avatarcolor: cyan[700],
    icon: <WiStrongWind />,
  },

  pcount: {
    avatarcolor: orange[900],
    icon: <IconUsers />,
    symbol: "pers.",
  },
});

export const propsTempertureCard = Object.freeze({
  icon: <IconTemperatureCelsius fontSize="inherit" />,
  bgColor: red[200],
  avatarcolor: red[800],
  colorFrom: red[100],
  colorAvg: red[500],
  colorTo: red[800],
  symbol: " °C ",
  yLabel: "temperature_celsius",
  xLabel: "hour",
});

export const propsUmidityCard = Object.freeze({
  icon: <IconDroplet fontSize="inherit" style={{ width: 18, height: 18 }} />,
  bgColor: indigo[200],
  avatarcolor: indigo[800],
  colorFrom: indigo[100],
  colorAvg: indigo[500],
  colorTo: indigo[800],
  symbol: " % ",
  yLabel: "Humidity-percentage",
  xLabel: "hour",
});

export const propsCo2Card = Object.freeze({
  icon: <Co2Icon fontSize="inherit" style={{ width: 22, height: 22 }} />,

  bgColor: grey[400],
  avatarcolor: grey[800],
  colorTo: grey[800],
  colorFrom: grey[300],
  colorAvg: grey[700],

  symbol: " ppm ",
  yLabel: "CO2 (ppm)",
  xLabel: "hour",
});

export const propsLuxCard = Object.freeze({
  icon: <WbSunnyOutlinedIcon fontSize="inherit" />,
  bgColor: yellow[600],
  avatarcolor: yellow[900],
  symbol: " lux ",
  colorTo: yellow[800],
  colorFrom: yellow[100],
  colorAvg: yellow[500],
  yLabel: "Illuminamento (lux)",
  xLabel: "hour",
});

export const propsBarPressCard = Object.freeze({
  icon: <BarPressIcon />,
  symbol: " hPa ",
  yLabel: "Atmospheric_pressure_symbol",
  xLabel: "hour",
  bgColor: green[200],
  avatarcolor: green[800],
  colorTo: green[800],
  colorFrom: green[100],
  colorAvg: green[500],
});
export const propsPM2_5Card = Object.freeze({
  icon: <WiDust />,
  bgColor: deepPurple[200],
  avatarcolor: deepPurple[800],
  symbol: " µg/m³ ",
});
export const propsPM10Card = Object.freeze({
  icon: <WiDust />,
  bgColor: purple[200],
  avatarcolor: purple[800],
  symbol: " µg/m³ ",
});

export const propsPMCard = Object.freeze({
  icon: <WiDust />,
  bgColor: grey[500],
  avatarcolor: grey[800],
  symbol: " µg/m³ ",
  xLabel: "hour",

  colorTo: purple[700],
  colorFrom: purple[100],
  colorAvg: purple[500],
  trace1Props: {
    bgColor: purple[200],
    avatarcolor: purple[800],
    colorTo: purple[700],
    colorFrom: purple[100],
    colorAvg: purple[500],
  },
  trace2Props: {
    bgColor: deepPurple[200],
    avatarcolor: deepPurple[800],
    colorTo: deepPurple[700],
    colorFrom: deepPurple[100],
    colorAvg: deepPurple[500],
  },
  yLabel: {
    labelGeneric: "PM (µg/m³)",
    trace1: "PM 10",
    trace2: "PM 2.5",
  },
});

export const propsRainCard = Object.freeze({
  icon: <UmbrellaIcon />,
  bgColor: blue[200],
  avatarcolor: blue[500],
  symbol: " mm ",
});

export const propsRainPeakCard = Object.freeze({
  icon: <UmbrellaIcon />,
  bgColor: "#80bff2",
  avatarcolor: "#1d5c8f",
  symbol: " mm ",
});

export const propsRainGenericCard = Object.freeze({
  icon: <UmbrellaIcon />,
  bgColor: grey[500],
  avatarcolor: grey[800],
  symbol: " mm ",
  yLabel: {
    labelGeneric: "Precipitazioni (mm)",
    trace1: "Intensità",
    trace2: "Picco",
  },
  xLabel: "hour",
  trace1Props: {
    colorTo: blue[600],
    colorFrom: blue[200],
    colorAvg: blue[400],
    bgColor: blue[200],
    avatarcolor: blue[500],
  },
  trace2Props: {
    colorTo: "#1d5c8f",
    colorFrom: "#80bff2",
    colorAvg: "#2169a5",
    bgColor: "#80bff2",
    avatarcolor: "#1d5c8f",
  },
});

export const propsWindCard = Object.freeze({
  icon: <WiStrongWind />,
  bgColor: cyan[300],
  avatarcolor: cyan[700],
  symbol: " km/h ",
});
export const propsWindDirCard = Object.freeze({
  icon: <WiStrongWind />,
  bgColor: cyan[300],
  avatarcolor: cyan[700],
});
export const propsPCountCard = Object.freeze({
  icon: <IconUsers style={{ width: 18, height: 18 }} />,
  bgColor: orange[400],
  avatarcolor: orange[900],
  symbol: " pers.",
  yLabel: "Number of person",
  xLabel: "hour",

  colorTo: orange[800],
  colorFrom: orange[100],
  colorAvg: orange[500],
});

export const propsLegendMetric = {
  air_hum: {
    colors: `#eff3ff,#c6dbef,#9ecae1,#6baed6,#3182bd,#08519c`,
    values: {
      label: "%",
      items: [
        { value: 25 },
        { value: 40 },
        { value: 45 },
        { value: 70 },
        { value: 85 },
        { value: 100 },
      ],
    },
  },
  bar_press: {
    colors: `#ffffcc,#d9f0a3,#addd8e,#78c679,#31a354,#006837`,
    values: {
      label: "hPa",
      items: [
        { value: 950 },
        { value: 970 },
        { value: 990 },
        { value: 1010 },
        { value: 1030 },
        { value: 1050 },
      ],
    },
  },
  CO2: {
    colors: `#f7f7f7,#d9d9d9,#bdbdbd,#969696,#636363,#252525`,
    values: {
      label: "ppm",
      items: [
        { value: 250 },
        { value: 400 },
        { value: 450 },
        { value: 700 },
        { value: 850 },
        { value: 1000 },
      ],
    },
  },
  lux: {
    colors: `#ffffb2,#fed976,#feb24c,#fd8d3c,#f03b20,#bd0026`,
    values: {
      label: "lux",
      items: [
        { value: 0 },
        { value: 10000 },
        { value: 20000 },
        { value: 30000 },
        { value: 40000 },
        { value: 50000 },
      ],
    },
  },
  pcount: {
    colors: `#fdd0a2,#fdae6b,#fd8d3c,#e6550d,#a63603`,
    values: {
      label: "pers",
      items: [
        { value: 0 },
        { value: 50 },
        { value: 100 },
        { value: 150 },
        { value: 200 },
        { value: 250 },
      ],
    },
  },
  pm10: {
    colors: `#EDD1CA,#C99DA4,#A6758E,#83537C,#573660,#2C1E3D`,
    values: {
      label: "µg/m³",
      items: [
        { value: 0 },
        { value: 20 },
        { value: 40 },
        { value: 60 },
        { value: 80 },
        { value: 100 },
      ],
    },
  },
  pm2_5: {
    colors: `#d1c4e9,#9575cd,#7e57c2,#673ab7,#512da8,#4527a0,#311b92`,
    values: {
      label: "µg/m³",
      items: [
        { value: 0 },
        { value: 10 },
        { value: 20 },
        { value: 30 },
        { value: 40 },
        { value: 50 },
      ],
    },
  },
  rain_intensity: {
    colors: `#eff3ff,#c6dbef,#9ecae1,#6baed6,#3182bd,#08519c`,
    values: {
      label: "mm",
      items: [
        { value: 0 },
        { value: 4 },
        { value: 8 },
        { value: 12 },
        { value: 16 },
        { value: 20 },
      ],
    },
  },
  wind_speed: {
    colors: `#ffffcc,#c7e9b4,#7fcdbb,#41b6c4,#2c7fb8,#253494`,
    values: {
      label: "km/h",
      items: [
        { value: 0 },
        { value: 10 },
        { value: 20 },
        { value: 30 },
        { value: 40 },
        { value: 50 },
      ],
    },
  },
};
